import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const DomainCryptoResponseSchema = z.object({
    eDomainKeyByAdminKey: z.string(),
});
export class DomainCryptoResponseDto extends createZodDto(DomainCryptoResponseSchema) {
}
